// import React,{useEffect,useState} from 'react'

// function Customer() {
//   const [users,setUser]=useState([])
//   useEffect(()=>{
//     fetch("http://35.208.65.24:3007/customers").then((result)=>{
//       result.json().then((resp)=>{
//         // console.log(resp)
//         setUser(resp.data)
//       })
//     })
//   },[])
//   console.log(users)

//   return (
//     <div>
//       <h1>REGISTERED USER DETAILS </h1>
//       <table border="1">
//        <tbody>
//        <tr>
//           <td>ID</td>
//           <td>First Name</td>
//           <td>Last Name</td>
//           <td>Email</td>
//           <td>Password</td>
//           <td>Phone</td>
//           <td>Address</td>
//           <td>Address2</td>
//           <td>City</td>
//           <td>State</td>
//           <td>Country</td>

//         </tr>
//         {
//           users.map((item,i)=>
//             <tr key={i}>
//             <td>{item.userId}</td>
//           <td>{item.firstname}</td>
//           <td>{item.lastname}</td>
//           <td>{item.email}</td>
//           <td>{item.password}</td>
//           <td>{item.phone}</td>
//           <td>{item.address}</td>
//           <td>{item.address2}</td>
//           <td>{item.city}</td>
//           <td>{item.state}</td>
//           <td>{item.country}</td>

//           </tr>
//           )
//         }
//        </tbody>
//       </table>
//     </div>

//   );
// }
// export default Customer;

// import Reac, { useEffect } from 'react';
import { Button, Paper, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import AgGridPaginatedTable from "../../components/AgGridPaginatedTable.jsx";

import { getCases } from "../../api/cases.js";
import { casesTable, customerTable } from "../../config/grid-column-defs.js";
import { getCustomers } from "../../api/customer.js";
import React, { useState } from "react";
import useErrorHandler from "../../hooks/useErrorHandler.js";

export default function Customer() {
  const { data: user } = useSelector((state) => state.user);

  const [caseTableRefreshCount, setCaseTableRefreshCount] = useState(0);
  const handleError = useErrorHandler();
  async function getCaseTableData(limit, offset) {
    try {
      const data = await getCustomers(user.token);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      handleError(error);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }
  return (
    <>
      <Paper className="odr-card">
        <Box
          display="flex"
          justifyContent="space-between"
          className="odr-card-header"
        >
          <Typography className="heading-title">Customers</Typography>
          <Box display="flex" justifyContent="flex-end" columnGap={2}>
            <Link to="/cases/new">
              {/* <Button variant="contained" size="small" color="primary">Create Case</Button> */}
            </Link>
          </Box>
        </Box>
        <div className="odr-main-table">
          <AgGridPaginatedTable
            getTableRows={getCaseTableData}
            columns={customerTable}
            perPage={10}
            refreshCounter={caseTableRefreshCount}
          />
        </div>
      </Paper>
    </>
  );
}
